import API_BASE_URL from "../config";

const authHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

const authHeadersNoContentType = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

const handle = async (res) => {
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(text || `Request failed with status ${res.status}`);
  }
  const text = await res.text();
  return text ? JSON.parse(text) : null;
};

export const list = (params = {}) => {
  const qs = new URLSearchParams();
  if (params.stage) qs.set("stage", params.stage);
  if (params.result) qs.set("result", params.result);
  if (params.search) qs.set("search", params.search);
  return fetch(`${API_BASE_URL}/api/placements?${qs}`, { headers: authHeaders() }).then(handle);
};

export const getById = (id) =>
  fetch(`${API_BASE_URL}/api/placements/${id}`, { headers: authHeaders() }).then(handle);

export const create = (fields, resumeFile) => {
  const form = new FormData();
  Object.entries(fields).forEach(([k, v]) => form.append(k, v ?? ""));
  if (resumeFile) form.append("resume", resumeFile);
  return fetch(`${API_BASE_URL}/api/placements`, {
    method: "POST",
    headers: authHeadersNoContentType(),
    body: form,
  }).then(handle);
};

export const update = (id, payload) =>
  fetch(`${API_BASE_URL}/api/placements/${id}`, {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  }).then(handle);

export const replaceResume = (id, resumeFile) => {
  const form = new FormData();
  form.append("resume", resumeFile);
  return fetch(`${API_BASE_URL}/api/placements/${id}/resume`, {
    method: "POST",
    headers: authHeadersNoContentType(),
    body: form,
  }).then(handle);
};

// Fetches the resume as a Blob (auth header can't be attached to a plain
// <iframe src>, so the caller turns this into an object URL and embeds that
// in an in-app viewer instead of a bare `window.open` new tab).
export const fetchResumeBlob = async (id) => {
  const res = await fetch(`${API_BASE_URL}/api/placements/${id}/resume`, { headers: authHeadersNoContentType() });
  if (!res.ok) throw new Error("Resume not found");
  return res.blob();
};

export const addStage = (id, payload) =>
  fetch(`${API_BASE_URL}/api/placements/${id}/stage`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  }).then(handle);

export const updateStageEntry = (candidateId, historyId, payload) =>
  fetch(`${API_BASE_URL}/api/placements/${candidateId}/stage/${historyId}`, {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  }).then(handle);

export const setResult = (id, payload) =>
  fetch(`${API_BASE_URL}/api/placements/${id}/result`, {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  }).then(handle);

export const exportExcel = async (params = {}) => {
  const qs = new URLSearchParams();
  if (params.search) qs.set("search", params.search);
  if (params.stage) qs.set("stage", params.stage);
  if (params.result) qs.set("result", params.result);
  if (params.from) qs.set("from", params.from);
  if (params.to) qs.set("to", params.to);

  const res = await fetch(`${API_BASE_URL}/api/placements/report?${qs}`, {
    headers: authHeadersNoContentType(),
  });
  if (!res.ok) throw new Error("Failed to download report");

  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  const date = new Date().toISOString().slice(0, 10);
  const hasFilters = Boolean(params.search) || Boolean(params.stage) || Boolean(params.result) || params.from || params.to;
  a.href = url;
  a.download = hasFilters ? `Candidates_Filtered_${date}.xlsx` : `Candidates_${date}.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

export const remove = (id) =>
  fetch(`${API_BASE_URL}/api/placements/${id}`, {
    method: "DELETE",
    headers: authHeadersNoContentType(),
  }).then((res) => {
    if (!res.ok) throw new Error("Failed to delete candidate");
  });
